<div class="sfe-support alert alert-danger " role="alert">
    Sorry about this! Our app is not fully optimized for this screen. 
    Please report your current screen size using the feedback link in the left panel 
    and our engineers will do their best to get this looking beautiful for you.
</div>